import React, {useContext, useState} from 'react'
import {Button, Checkbox, message, Modal, Popconfirm, Select} from "antd"
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import parseToken from "../../../../helpers/parseToken"
import {SettingLayoutContext} from "../../context/SettingLayoutContext"
import {addLayOutConfigItem} from "../../../../services/api/apiSetting"

const AddLayoutSetting = () => {
    const SettingLayoutPageContext = useContext(SettingLayoutContext)
    const {
        getListLayout,
        tenant,
        listLayoutType,
        listLayoutBlock,
        listLayoutField,
        listFieldType
    } = SettingLayoutPageContext

    const info = parseToken()
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [validate, setValidate] = useState({})
    const [error, setError] = useState('')
    const [item, setItem] = useState({
        fieldRequired: 0
    })


    const _handleChangeChecked = (e) => {
        const checked = e.target.checked

        const {name} = e.target
        setItem({
            ...item,
            [name]: checked ? 1 : 0
        })

        setError('')
        delete validate[name]
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setItem({
            ...item,
            [name]: value
        })

        setError('')
        delete validate[name]
    }

    const _handleChangeSelect = (name, value) => {
        setItem({
            ...item,
            [name]: value
        })
        setError('')
        delete validate[name]
    }

    const _onToggleModal = () => {
        setIsOpen(!isOpen)
    }

    const _onCancel = () => {
        setIsOpen(false)
        _resetInfo()
    }

    const _resetInfo = () => {
        setItem({fieldRequired: 0})
    }

    const _validateData = () => {
        let validateForm = {}


        if (item.tenantId === undefined || item.tenantId === '') {
            Object.assign(validateForm, {tenantId: 'Tenant là bắt buộc'})
        }
        if (item.layoutType === undefined || item.layoutType === '') {
            Object.assign(validateForm, {layoutType: 'Loại layout là bắt buộc'})
        }
        if (item.layoutBlock === undefined || item.layoutBlock === '') {
            Object.assign(validateForm, {layoutBlock: 'Block là bắt buộc'})
        }
        if (item.layoutField === undefined || item.layoutField === '') {
            Object.assign(validateForm, {layoutField: 'Thông tin là bắt buộc'})
        }
        if (item.fieldType === undefined || item.fieldType === '') {
            Object.assign(validateForm, {fieldType: 'Kiểu dữ liệu là bắt buộc'})
        }
        if (item.fieldTitle === undefined || item.fieldTitle === '') {
            Object.assign(validateForm, {fieldTitle: 'Tiêu đề là bắt buộc'})
        }
        if (item.fieldTitle && item.fieldTitle !== '' && item.fieldTitle.length > 100) {
            Object.assign(validateForm, {fieldTitle: 'Tiêu đề không được quá 100 ký tự'})
        }
        if (item.fieldDefaultValue && item.fieldDefaultValue !== '' && item.fieldDefaultValue.length > 100) {
            Object.assign(validateForm, {fieldDefaultValue: 'Giá trị mặc định không được quá 100 ký tự'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const onAddSettingLayout = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                message.error("Dữ liệu không hợp lệ")

                return false
            }

            const payload = {
                ...item,
                fieldOrder: parseInt(item.fieldOrder)
            }

            const response = await addLayOutConfigItem(payload, info.sub)

            const {success, error_message} = response

            if (success !== '1') {
                setLoading(false)
                message.error(error_message)

                return false
            }

            setLoading(false)
            message.success("Thêm mới setting layout thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }


    const _onSave = async () => {
        const response = await onAddSettingLayout()

        if (response !== false) {
            if (typeof getListLayout === 'function') {
                await getListLayout()
            }
            _onCancel()
        }
    }

    const _onSaveAndNew = async () => {
        const response = await onAddSettingLayout()
        if (response !== false) {
            if (typeof getListLayout === 'function') {
                await getListLayout()
            }
            await _resetInfo()
        }
    }

    return (
        <>
            <button className="ButtonCustom mr-3" onClick={_onToggleModal}>
                <PlusIcon width={12} height={12}/>
                Thêm mới
            </button>
            <Modal
                title="Thêm mới layout setting"
                className="ModalCustom2 FormEdit"
                maskClosable={false}
                visible={isOpen}
                footer={[
                    <div className="Actions d-flex justify-content-end align-items-center">
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={_onCancel}
                                    okText="Yes" cancelText="No">
                            <Button key="back" type="link" disable={loading}>
                                Cancel
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới setting layout?"
                                    onConfirm={_onSaveAndNew} okText="Yes" cancelText="No">
                            <Button key="submit2" loading={loading}>
                                Save & New
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu setting layout?" onConfirm={_onSave}
                                    okText="Yes" cancelText="No">
                            <Button key="submit" type="primary" loading={loading}>
                                Save
                            </Button>
                        </Popconfirm>
                    </div>
                ]}
            >
                <div className="FormAddNew">
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.tenantId && 'error'}`}>
                                <label className="Label" htmlFor="tenantId">
                                    Tenant:
                                    <span className="Required">*</span>
                                </label>
                                <Select id="tenantId " name="tenantId" defaultValue={item.tenantId}
                                        onChange={(value) => _handleChangeSelect('tenantId', value)}
                                        placeholder="Vui lòng chọn tenant"
                                >
                                    {
                                        tenant.map((item, index) => (
                                            <Select.Option key={`tenantId${index}`}
                                                           value={item.id}>{item.name}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.tenantId && <span className="Error text-danger">{validate.tenantId}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.layoutType && 'error'}`}>
                                <label className="Label" htmlFor="layoutType">
                                    Loại layout:
                                    <span className="Required">*</span>
                                </label>
                                <Select
                                    id="layoutType"
                                    name="layoutType"
                                    defaultValue={item.layoutType}
                                    onChange={(value) => _handleChangeSelect('layoutType', value)}
                                    placeholder="Vui lòng chọn loại layout"
                                >
                                    {
                                        listLayoutType.map((item, index) => (
                                            <Select.Option
                                                key={`layoutType${index}`}
                                                value={item.value}
                                            >{item.name}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.layoutType &&
                                    <span className="Error text-danger">{validate.layoutType}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.fieldTitle && 'error'}`}>
                                <label className="Label" htmlFor="layoutBlock">
                                    Tiêu đề:
                                    <span className="Required">*</span>
                                </label>
                                <input
                                    id="layoutBlock"
                                    value={item.fieldTitle || ''}
                                    type="text"
                                    name="fieldTitle"
                                    placeholder="Tiêu đề"
                                    onChange={_handleChangeInput}
                                />
                                {
                                    validate.fieldTitle &&
                                    <span className="Error text-danger">{validate.fieldTitle}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.layoutField && 'error'}`}>
                                <label className="Label" htmlFor="layoutField">
                                    Thông tin:
                                    <span className="Required">*</span>
                                </label>
                                <Select id="layoutField" name="layoutField" defaultValue={item.layoutField}
                                        onChange={(value) => _handleChangeSelect('layoutField', value)}
                                        placeholder="Vui lòng chọn thông tin"
                                >
                                    {
                                        listLayoutField.map((item, index) => (
                                            <Select.Option
                                                key={`layoutField${index}`}
                                                value={item.value}
                                            >{item.name}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.layoutField &&
                                    <span className="Error text-danger">{validate.layoutField}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.fieldType && 'error'}`}>
                                <label className="Label" htmlFor="fieldType">
                                    Kiểu dữ liệu:
                                    <span className="Required">*</span>
                                </label>
                                <Select
                                    id="fieldType"
                                    name="fieldType"
                                    defaultValue={item.fieldType}
                                    onChange={(value) => _handleChangeSelect('fieldType', value)}
                                    placeholder="Vui lòng chọn kiểu dữ liệu"
                                >
                                    {
                                        listFieldType.map((item, index) => (
                                            <Select.Option key={`fieldType${index}`}
                                                           value={item.value}>{item.name}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.fieldType &&
                                    <span className="Error text-danger">{validate.fieldType}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.fieldRequired && 'error'}`}>
                                <label className="Label" htmlFor="fieldRequired">
                                    Bắt buộc:
                                </label>
                                <Checkbox
                                    id="fieldRequired"
                                    name='fieldRequired'
                                    checked={item.fieldRequired === 1}
                                    onChange={_handleChangeChecked}
                                >Bắt buộc</Checkbox>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.layoutBlock && 'error'}`}>
                                <label className="Label" htmlFor="layoutBlock">
                                    Block:
                                    <span className="Required">*</span>
                                </label>
                                <Select id="layoutBlock" name="layoutBlock" defaultValue={item.layoutBlock}
                                        onChange={(value) => _handleChangeSelect('layoutBlock', value)}
                                        placeholder="Vui lòng chọn block"
                                >
                                    {
                                        listLayoutBlock.map((item, index) => (
                                            <Select.Option
                                                key={`layoutBlock${index}`}
                                                value={item.value}
                                            >{item.name}</Select.Option>
                                        ))
                                    }
                                </Select>
                                {
                                    validate.layoutBlock &&
                                    <span className="Error text-danger">{validate.layoutBlock}</span>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`FieldItem ${validate.fieldOrder && 'error'}`}>
                                <label className="Label" htmlFor="fieldOrder">
                                    Thứ tự:
                                </label>
                                <input
                                    id="fieldOrder"
                                    value={item.fieldOrder || ''}
                                    type="number"
                                    name="fieldOrder"
                                    placeholder="Giá trị mặc định"
                                    onChange={_handleChangeInput}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className={`FieldItem ${validate.fieldDefaultValue && 'error'}`}>
                                <label className="Label" htmlFor="fieldDefaultValue">
                                    Giá trị mặc định:
                                </label>
                                <textarea
                                    id="fieldDefaultValue"
                                    value={item.fieldDefaultValue || ''}
                                    name="fieldDefaultValue"
                                    placeholder="Giá trị mặc định"
                                    cols={30}
                                    rows={4}
                                    onChange={_handleChangeInput}
                                />
                                {
                                    validate.fieldDefaultValue &&
                                    <span className="Error text-danger">{validate.fieldDefaultValue}</span>
                                }
                            </div>
                        </div>
                    </div>

                    {error && <div className="text-danger mt-3">{error}</div>}
                </div>
            </Modal>
        </>
    )
}

export default AddLayoutSetting
